import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { MenuItem } from 'react-bootstrap/lib';
import withDealerPermission from './dealerPermission';

const getStatus = dealer => {
  dealer.status = 'pending';
  return ' ';
};

function ValidateButton({ dealer, onValidate }) {
  const status = getStatus(dealer);
  if (!dealer) {
    return null;
  }
  return (
    <MenuItem
      onClick={() => onValidate(dealer)}
      disabled={status === 'pending'}
    >
      Run Validation Tests
    </MenuItem>
  );
}

ValidateButton.propTypes = {
  dealer: PropTypes.object,
  onValidate: PropTypes.func,
};

export default withDealerPermission(Permissions.CREATE)(ValidateButton);
